import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { CategoryItem } from '@app/shared/interfaces/categoryItem';
import { Room } from '@app/shared/interfaces/room';
import { Session } from '@app/shared/interfaces/session';
import { Speaker } from '@app/shared/interfaces/speaker';
import { StaticJsonDataService } from '@app/shared/services/static-json-data-service';

@Component({
  selector: 'app-session',
  templateUrl: 'session.component.html'
})
export class SessionComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private staticJsonDataService: StaticJsonDataService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  @Input() session!:Session;
  @Input() showPersona = true;
  @Input() showTime = true;
  @Input() showLocation = true;
  @Input() showDescription = true;

  isBrowser = false;
  jsonFile: string = 'allSessionizeData.json';
  room!: Room;
  speakers: Speaker[] = [];
  categoryItems: CategoryItem[] = [];

  ngOnInit(): void {
    if (this.isBrowser) {
      this.setRoomById();
      this.setSpeakersById();
      this.setCategoryItemsById();
    }
  }

  setCategoryItemsById() {
    this.staticJsonDataService
      .fetchJsonData(this.jsonFile)
      .then((jsonData:any) => {
        if (jsonData.categories) {
          const track:[] = jsonData.categories.filter((category:any) => category.title === 'Track')[0]?.items;
          const level:[] = jsonData.categories.filter((category:any) => category.title === 'Level')[0]?.items;
          const trackItems = track.filter((item:CategoryItem) => this.session.categoryItems.indexOf(Number(item.id)) !== -1);
          const levelItems = level.filter((item:CategoryItem) => this.session.categoryItems.indexOf(Number(item.id)) !== -1);

          this.categoryItems = trackItems.concat(levelItems);
        }
      });
  }

  setRoomById() {
    this.staticJsonDataService
      .fetchJsonData(this.jsonFile)
      .then((jsonData:any) => {
        if (jsonData.rooms) {
          this.room = jsonData.rooms.filter((room:any) => room.id === this.session.roomId)[0];
        }
      });
  }

  setSpeakersById() {
    this.staticJsonDataService
      .fetchJsonData(this.jsonFile)
      .then((jsonData:any) => {
        this.speakers = jsonData.speakers.filter((speaker:Speaker) => {
          return this.session.speakers.indexOf(speaker.id) !== -1
        });
      });
  }

  handleButtonClick():void {
    this.showDescription = !this.showDescription;
  }
}
